/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnitsRouteImport } from './routes/units'
import { Route as TagsRouteImport } from './routes/tags'
import { Route as SuperadminLoginRouteImport } from './routes/superadmin-login'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ProfitLossRouteImport } from './routes/profit-loss'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IngredientsRouteImport } from './routes/ingredients'
import { Route as HomeRouteImport } from './routes/home'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CostReportsRouteImport } from './routes/cost-reports'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PeopleIndexRouteImport } from './routes/people/index'
import { Route as PaymentsIndexRouteImport } from './routes/payments/index'
import { Route as PartnersIndexRouteImport } from './routes/partners/index'
import { Route as MetricsIndexRouteImport } from './routes/metrics/index'
import { Route as MenusIndexRouteImport } from './routes/menus/index'
import { Route as InvoicesIndexRouteImport } from './routes/invoices/index'
import { Route as InventoryIndexRouteImport } from './routes/inventory/index'
import { Route as CostCentersIndexRouteImport } from './routes/cost-centers/index'
import { Route as BankTransactionsIndexRouteImport } from './routes/bank-transactions/index'
import { Route as SalesProductsRouteImport } from './routes/sales/products'
import { Route as SalesInvoicesRouteImport } from './routes/sales/invoices'
import { Route as SalesIntegrationsRouteImport } from './routes/sales/integrations'
import { Route as SalesDebugFruitsysRouteImport } from './routes/sales/debug-fruitsys'
import { Route as SalesDashboardRouteImport } from './routes/sales/dashboard'
import { Route as PeopleTimesheetsRouteImport } from './routes/people/timesheets'
import { Route as PeopleGroupsRouteImport } from './routes/people/groups'
import { Route as PeopleCostsRouteImport } from './routes/people/costs'
import { Route as PeopleContractsRouteImport } from './routes/people/contracts'
import { Route as PaymentsNewRouteImport } from './routes/payments/new'
import { Route as PaymentsIdRouteImport } from './routes/payments/$id'
import { Route as PartnersIdRouteImport } from './routes/partners/$id'
import { Route as MetricsIdRouteImport } from './routes/metrics/$id'
import { Route as MenusNewRouteImport } from './routes/menus/new'
import { Route as MenusIdRouteImport } from './routes/menus/$id'
import { Route as InvoicesUploadRouteImport } from './routes/invoices/upload'
import { Route as InvoicesManualMatchRouteImport } from './routes/invoices/manual-match'
import { Route as InvoicesGdriveFilesRouteImport } from './routes/invoices/gdrive-files'
import { Route as InvoicesIdRouteImport } from './routes/invoices/$id'
import { Route as InventoryTransactionsRouteImport } from './routes/inventory/transactions'
import { Route as InventoryNewRouteImport } from './routes/inventory/new'
import { Route as InventoryMasterIngredientsRouteImport } from './routes/inventory/master-ingredients'
import { Route as FinanceTaxesRouteImport } from './routes/finance/taxes'
import { Route as FinanceReconciliationRouteImport } from './routes/finance/reconciliation'
import { Route as CostCentersIdRouteImport } from './routes/cost-centers/$id'
import { Route as AdminTagsRouteImport } from './routes/admin/tags'
import { Route as AdminNotificationsRouteImport } from './routes/admin/notifications'
import { Route as AdminLocalCategoryModelsRouteImport } from './routes/admin/local-category-models'
import { Route as AdminDataImportRouteImport } from './routes/admin/data-import'
import { Route as AdminCurrenciesRouteImport } from './routes/admin/currencies'
import { Route as AdminCategoryManagementRouteImport } from './routes/admin/category-management'
import { Route as SuperadminTenantsIndexRouteImport } from './routes/superadmin/tenants/index'
import { Route as SuperadminSuperadminsIndexRouteImport } from './routes/superadmin/superadmins/index'
import { Route as SalesOrdersIndexRouteImport } from './routes/sales/orders/index'
import { Route as PeopleTimeoffIndexRouteImport } from './routes/people/timeoff/index'
import { Route as PeopleSchedulersIndexRouteImport } from './routes/people/schedulers/index'
import { Route as PeopleEmployeesIndexRouteImport } from './routes/people/employees/index'
import { Route as InventoryBatchesIndexRouteImport } from './routes/inventory/batches/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminPeopleIndexRouteImport } from './routes/admin/people/index'
import { Route as AdminIntegrationsIndexRouteImport } from './routes/admin/integrations/index'
import { Route as AdminFinanceIndexRouteImport } from './routes/admin/finance/index'
import { Route as SuperadminTenantsNewRouteImport } from './routes/superadmin/tenants/new'
import { Route as SuperadminTenantsIdRouteImport } from './routes/superadmin/tenants/$id'
import { Route as SalesOrdersIdRouteImport } from './routes/sales/orders/$id'
import { Route as PeopleTimeoffRequestsRouteImport } from './routes/people/timeoff/requests'
import { Route as PeopleSchedulersGenerateScheduleRouteImport } from './routes/people/schedulers/generate-schedule'
import { Route as PeopleSchedulersIdRouteImport } from './routes/people/schedulers/$id'
import { Route as PeopleEmployeesEmployeeIdRouteImport } from './routes/people/employees/$employeeId'
import { Route as PaymentsIdEditRouteImport } from './routes/payments/$id/edit'
import { Route as MetricsExecuteIdRouteImport } from './routes/metrics/execute/$id'
import { Route as MenusIdEditRouteImport } from './routes/menus/$id/edit'
import { Route as InventoryBatchesReceiveShipmentRouteImport } from './routes/inventory/batches/receive-shipment'
import { Route as InventoryBatchesIdRouteImport } from './routes/inventory/batches/$id'
import { Route as AdminUsersIdRouteImport } from './routes/admin/users/$id'
import { Route as AdminIntegrationsConnecteamRouteImport } from './routes/admin/integrations/connecteam'
import { Route as AdminFinancePaymentInstrumentsNewRouteImport } from './routes/admin/finance/payment-instruments/new'
import { Route as AdminFinancePaymentInstrumentsIdRouteImport } from './routes/admin/finance/payment-instruments/$id'
import { Route as AdminFinanceCompaniesNewRouteImport } from './routes/admin/finance/companies/new'
import { Route as AdminFinanceCompaniesIdRouteImport } from './routes/admin/finance/companies/$id'

const UnitsRoute = UnitsRouteImport.update({
  id: '/units',
  path: '/units',
  getParentRoute: () => rootRouteImport,
} as any)
const TagsRoute = TagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperadminLoginRoute = SuperadminLoginRouteImport.update({
  id: '/superadmin-login',
  path: '/superadmin-login',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfitLossRoute = ProfitLossRouteImport.update({
  id: '/profit-loss',
  path: '/profit-loss',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IngredientsRoute = IngredientsRouteImport.update({
  id: '/ingredients',
  path: '/ingredients',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CostReportsRoute = CostReportsRouteImport.update({
  id: '/cost-reports',
  path: '/cost-reports',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesRoute = CategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIndexRoute = PeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsIndexRoute = PaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersIndexRoute = PartnersIndexRouteImport.update({
  id: '/partners/',
  path: '/partners/',
  getParentRoute: () => rootRouteImport,
} as any)
const MetricsIndexRoute = MetricsIndexRouteImport.update({
  id: '/metrics/',
  path: '/metrics/',
  getParentRoute: () => rootRouteImport,
} as any)
const MenusIndexRoute = MenusIndexRouteImport.update({
  id: '/menus/',
  path: '/menus/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIndexRoute = InvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryIndexRoute = InventoryIndexRouteImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => rootRouteImport,
} as any)
const CostCentersIndexRoute = CostCentersIndexRouteImport.update({
  id: '/cost-centers/',
  path: '/cost-centers/',
  getParentRoute: () => rootRouteImport,
} as any)
const BankTransactionsIndexRoute = BankTransactionsIndexRouteImport.update({
  id: '/bank-transactions/',
  path: '/bank-transactions/',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesProductsRoute = SalesProductsRouteImport.update({
  id: '/sales/products',
  path: '/sales/products',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesInvoicesRoute = SalesInvoicesRouteImport.update({
  id: '/sales/invoices',
  path: '/sales/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesIntegrationsRoute = SalesIntegrationsRouteImport.update({
  id: '/sales/integrations',
  path: '/sales/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesDebugFruitsysRoute = SalesDebugFruitsysRouteImport.update({
  id: '/sales/debug-fruitsys',
  path: '/sales/debug-fruitsys',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesDashboardRoute = SalesDashboardRouteImport.update({
  id: '/sales/dashboard',
  path: '/sales/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleTimesheetsRoute = PeopleTimesheetsRouteImport.update({
  id: '/people/timesheets',
  path: '/people/timesheets',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleGroupsRoute = PeopleGroupsRouteImport.update({
  id: '/people/groups',
  path: '/people/groups',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleCostsRoute = PeopleCostsRouteImport.update({
  id: '/people/costs',
  path: '/people/costs',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleContractsRoute = PeopleContractsRouteImport.update({
  id: '/people/contracts',
  path: '/people/contracts',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsNewRoute = PaymentsNewRouteImport.update({
  id: '/payments/new',
  path: '/payments/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsIdRoute = PaymentsIdRouteImport.update({
  id: '/payments/$id',
  path: '/payments/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersIdRoute = PartnersIdRouteImport.update({
  id: '/partners/$id',
  path: '/partners/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MetricsIdRoute = MetricsIdRouteImport.update({
  id: '/metrics/$id',
  path: '/metrics/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MenusNewRoute = MenusNewRouteImport.update({
  id: '/menus/new',
  path: '/menus/new',
  getParentRoute: () => rootRouteImport,
} as any)
const MenusIdRoute = MenusIdRouteImport.update({
  id: '/menus/$id',
  path: '/menus/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesUploadRoute = InvoicesUploadRouteImport.update({
  id: '/invoices/upload',
  path: '/invoices/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesManualMatchRoute = InvoicesManualMatchRouteImport.update({
  id: '/invoices/manual-match',
  path: '/invoices/manual-match',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesGdriveFilesRoute = InvoicesGdriveFilesRouteImport.update({
  id: '/invoices/gdrive-files',
  path: '/invoices/gdrive-files',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIdRoute = InvoicesIdRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryTransactionsRoute = InventoryTransactionsRouteImport.update({
  id: '/inventory/transactions',
  path: '/inventory/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryNewRoute = InventoryNewRouteImport.update({
  id: '/inventory/new',
  path: '/inventory/new',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryMasterIngredientsRoute =
  InventoryMasterIngredientsRouteImport.update({
    id: '/inventory/master-ingredients',
    path: '/inventory/master-ingredients',
    getParentRoute: () => rootRouteImport,
  } as any)
const FinanceTaxesRoute = FinanceTaxesRouteImport.update({
  id: '/finance/taxes',
  path: '/finance/taxes',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceReconciliationRoute = FinanceReconciliationRouteImport.update({
  id: '/finance/reconciliation',
  path: '/finance/reconciliation',
  getParentRoute: () => rootRouteImport,
} as any)
const CostCentersIdRoute = CostCentersIdRouteImport.update({
  id: '/cost-centers/$id',
  path: '/cost-centers/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTagsRoute = AdminTagsRouteImport.update({
  id: '/admin/tags',
  path: '/admin/tags',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNotificationsRoute = AdminNotificationsRouteImport.update({
  id: '/admin/notifications',
  path: '/admin/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLocalCategoryModelsRoute =
  AdminLocalCategoryModelsRouteImport.update({
    id: '/admin/local-category-models',
    path: '/admin/local-category-models',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminDataImportRoute = AdminDataImportRouteImport.update({
  id: '/admin/data-import',
  path: '/admin/data-import',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCurrenciesRoute = AdminCurrenciesRouteImport.update({
  id: '/admin/currencies',
  path: '/admin/currencies',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCategoryManagementRoute = AdminCategoryManagementRouteImport.update({
  id: '/admin/category-management',
  path: '/admin/category-management',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperadminTenantsIndexRoute = SuperadminTenantsIndexRouteImport.update({
  id: '/superadmin/tenants/',
  path: '/superadmin/tenants/',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperadminSuperadminsIndexRoute =
  SuperadminSuperadminsIndexRouteImport.update({
    id: '/superadmin/superadmins/',
    path: '/superadmin/superadmins/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SalesOrdersIndexRoute = SalesOrdersIndexRouteImport.update({
  id: '/sales/orders/',
  path: '/sales/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleTimeoffIndexRoute = PeopleTimeoffIndexRouteImport.update({
  id: '/people/timeoff/',
  path: '/people/timeoff/',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleSchedulersIndexRoute = PeopleSchedulersIndexRouteImport.update({
  id: '/people/schedulers/',
  path: '/people/schedulers/',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleEmployeesIndexRoute = PeopleEmployeesIndexRouteImport.update({
  id: '/people/employees/',
  path: '/people/employees/',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryBatchesIndexRoute = InventoryBatchesIndexRouteImport.update({
  id: '/inventory/batches/',
  path: '/inventory/batches/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPeopleIndexRoute = AdminPeopleIndexRouteImport.update({
  id: '/admin/people/',
  path: '/admin/people/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIntegrationsIndexRoute = AdminIntegrationsIndexRouteImport.update({
  id: '/admin/integrations/',
  path: '/admin/integrations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFinanceIndexRoute = AdminFinanceIndexRouteImport.update({
  id: '/admin/finance/',
  path: '/admin/finance/',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperadminTenantsNewRoute = SuperadminTenantsNewRouteImport.update({
  id: '/superadmin/tenants/new',
  path: '/superadmin/tenants/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperadminTenantsIdRoute = SuperadminTenantsIdRouteImport.update({
  id: '/superadmin/tenants/$id',
  path: '/superadmin/tenants/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesOrdersIdRoute = SalesOrdersIdRouteImport.update({
  id: '/sales/orders/$id',
  path: '/sales/orders/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleTimeoffRequestsRoute = PeopleTimeoffRequestsRouteImport.update({
  id: '/people/timeoff/requests',
  path: '/people/timeoff/requests',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleSchedulersGenerateScheduleRoute =
  PeopleSchedulersGenerateScheduleRouteImport.update({
    id: '/people/schedulers/generate-schedule',
    path: '/people/schedulers/generate-schedule',
    getParentRoute: () => rootRouteImport,
  } as any)
const PeopleSchedulersIdRoute = PeopleSchedulersIdRouteImport.update({
  id: '/people/schedulers/$id',
  path: '/people/schedulers/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleEmployeesEmployeeIdRoute =
  PeopleEmployeesEmployeeIdRouteImport.update({
    id: '/people/employees/$employeeId',
    path: '/people/employees/$employeeId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PaymentsIdEditRoute = PaymentsIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => PaymentsIdRoute,
} as any)
const MetricsExecuteIdRoute = MetricsExecuteIdRouteImport.update({
  id: '/metrics/execute/$id',
  path: '/metrics/execute/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MenusIdEditRoute = MenusIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => MenusIdRoute,
} as any)
const InventoryBatchesReceiveShipmentRoute =
  InventoryBatchesReceiveShipmentRouteImport.update({
    id: '/inventory/batches/receive-shipment',
    path: '/inventory/batches/receive-shipment',
    getParentRoute: () => rootRouteImport,
  } as any)
const InventoryBatchesIdRoute = InventoryBatchesIdRouteImport.update({
  id: '/inventory/batches/$id',
  path: '/inventory/batches/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIdRoute = AdminUsersIdRouteImport.update({
  id: '/admin/users/$id',
  path: '/admin/users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIntegrationsConnecteamRoute =
  AdminIntegrationsConnecteamRouteImport.update({
    id: '/admin/integrations/connecteam',
    path: '/admin/integrations/connecteam',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminFinancePaymentInstrumentsNewRoute =
  AdminFinancePaymentInstrumentsNewRouteImport.update({
    id: '/admin/finance/payment-instruments/new',
    path: '/admin/finance/payment-instruments/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminFinancePaymentInstrumentsIdRoute =
  AdminFinancePaymentInstrumentsIdRouteImport.update({
    id: '/admin/finance/payment-instruments/$id',
    path: '/admin/finance/payment-instruments/$id',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminFinanceCompaniesNewRoute =
  AdminFinanceCompaniesNewRouteImport.update({
    id: '/admin/finance/companies/new',
    path: '/admin/finance/companies/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminFinanceCompaniesIdRoute = AdminFinanceCompaniesIdRouteImport.update({
  id: '/admin/finance/companies/$id',
  path: '/admin/finance/companies/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/categories': typeof CategoriesRoute
  '/cost-reports': typeof CostReportsRoute
  '/dashboard': typeof DashboardRoute
  '/home': typeof HomeRoute
  '/ingredients': typeof IngredientsRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/profit-loss': typeof ProfitLossRoute
  '/settings': typeof SettingsRoute
  '/superadmin-login': typeof SuperadminLoginRoute
  '/tags': typeof TagsRoute
  '/units': typeof UnitsRoute
  '/admin/category-management': typeof AdminCategoryManagementRoute
  '/admin/currencies': typeof AdminCurrenciesRoute
  '/admin/data-import': typeof AdminDataImportRoute
  '/admin/local-category-models': typeof AdminLocalCategoryModelsRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/tags': typeof AdminTagsRoute
  '/cost-centers/$id': typeof CostCentersIdRoute
  '/finance/reconciliation': typeof FinanceReconciliationRoute
  '/finance/taxes': typeof FinanceTaxesRoute
  '/inventory/master-ingredients': typeof InventoryMasterIngredientsRoute
  '/inventory/new': typeof InventoryNewRoute
  '/inventory/transactions': typeof InventoryTransactionsRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/gdrive-files': typeof InvoicesGdriveFilesRoute
  '/invoices/manual-match': typeof InvoicesManualMatchRoute
  '/invoices/upload': typeof InvoicesUploadRoute
  '/menus/$id': typeof MenusIdRouteWithChildren
  '/menus/new': typeof MenusNewRoute
  '/metrics/$id': typeof MetricsIdRoute
  '/partners/$id': typeof PartnersIdRoute
  '/payments/$id': typeof PaymentsIdRouteWithChildren
  '/payments/new': typeof PaymentsNewRoute
  '/people/contracts': typeof PeopleContractsRoute
  '/people/costs': typeof PeopleCostsRoute
  '/people/groups': typeof PeopleGroupsRoute
  '/people/timesheets': typeof PeopleTimesheetsRoute
  '/sales/dashboard': typeof SalesDashboardRoute
  '/sales/debug-fruitsys': typeof SalesDebugFruitsysRoute
  '/sales/integrations': typeof SalesIntegrationsRoute
  '/sales/invoices': typeof SalesInvoicesRoute
  '/sales/products': typeof SalesProductsRoute
  '/bank-transactions': typeof BankTransactionsIndexRoute
  '/cost-centers': typeof CostCentersIndexRoute
  '/inventory': typeof InventoryIndexRoute
  '/invoices': typeof InvoicesIndexRoute
  '/menus': typeof MenusIndexRoute
  '/metrics': typeof MetricsIndexRoute
  '/partners': typeof PartnersIndexRoute
  '/payments': typeof PaymentsIndexRoute
  '/people': typeof PeopleIndexRoute
  '/admin/integrations/connecteam': typeof AdminIntegrationsConnecteamRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/inventory/batches/$id': typeof InventoryBatchesIdRoute
  '/inventory/batches/receive-shipment': typeof InventoryBatchesReceiveShipmentRoute
  '/menus/$id/edit': typeof MenusIdEditRoute
  '/metrics/execute/$id': typeof MetricsExecuteIdRoute
  '/payments/$id/edit': typeof PaymentsIdEditRoute
  '/people/employees/$employeeId': typeof PeopleEmployeesEmployeeIdRoute
  '/people/schedulers/$id': typeof PeopleSchedulersIdRoute
  '/people/schedulers/generate-schedule': typeof PeopleSchedulersGenerateScheduleRoute
  '/people/timeoff/requests': typeof PeopleTimeoffRequestsRoute
  '/sales/orders/$id': typeof SalesOrdersIdRoute
  '/superadmin/tenants/$id': typeof SuperadminTenantsIdRoute
  '/superadmin/tenants/new': typeof SuperadminTenantsNewRoute
  '/admin/finance': typeof AdminFinanceIndexRoute
  '/admin/integrations': typeof AdminIntegrationsIndexRoute
  '/admin/people': typeof AdminPeopleIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/inventory/batches': typeof InventoryBatchesIndexRoute
  '/people/employees': typeof PeopleEmployeesIndexRoute
  '/people/schedulers': typeof PeopleSchedulersIndexRoute
  '/people/timeoff': typeof PeopleTimeoffIndexRoute
  '/sales/orders': typeof SalesOrdersIndexRoute
  '/superadmin/superadmins': typeof SuperadminSuperadminsIndexRoute
  '/superadmin/tenants': typeof SuperadminTenantsIndexRoute
  '/admin/finance/companies/$id': typeof AdminFinanceCompaniesIdRoute
  '/admin/finance/companies/new': typeof AdminFinanceCompaniesNewRoute
  '/admin/finance/payment-instruments/$id': typeof AdminFinancePaymentInstrumentsIdRoute
  '/admin/finance/payment-instruments/new': typeof AdminFinancePaymentInstrumentsNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/categories': typeof CategoriesRoute
  '/cost-reports': typeof CostReportsRoute
  '/dashboard': typeof DashboardRoute
  '/home': typeof HomeRoute
  '/ingredients': typeof IngredientsRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/profit-loss': typeof ProfitLossRoute
  '/settings': typeof SettingsRoute
  '/superadmin-login': typeof SuperadminLoginRoute
  '/tags': typeof TagsRoute
  '/units': typeof UnitsRoute
  '/admin/category-management': typeof AdminCategoryManagementRoute
  '/admin/currencies': typeof AdminCurrenciesRoute
  '/admin/data-import': typeof AdminDataImportRoute
  '/admin/local-category-models': typeof AdminLocalCategoryModelsRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/tags': typeof AdminTagsRoute
  '/cost-centers/$id': typeof CostCentersIdRoute
  '/finance/reconciliation': typeof FinanceReconciliationRoute
  '/finance/taxes': typeof FinanceTaxesRoute
  '/inventory/master-ingredients': typeof InventoryMasterIngredientsRoute
  '/inventory/new': typeof InventoryNewRoute
  '/inventory/transactions': typeof InventoryTransactionsRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/gdrive-files': typeof InvoicesGdriveFilesRoute
  '/invoices/manual-match': typeof InvoicesManualMatchRoute
  '/invoices/upload': typeof InvoicesUploadRoute
  '/menus/$id': typeof MenusIdRouteWithChildren
  '/menus/new': typeof MenusNewRoute
  '/metrics/$id': typeof MetricsIdRoute
  '/partners/$id': typeof PartnersIdRoute
  '/payments/$id': typeof PaymentsIdRouteWithChildren
  '/payments/new': typeof PaymentsNewRoute
  '/people/contracts': typeof PeopleContractsRoute
  '/people/costs': typeof PeopleCostsRoute
  '/people/groups': typeof PeopleGroupsRoute
  '/people/timesheets': typeof PeopleTimesheetsRoute
  '/sales/dashboard': typeof SalesDashboardRoute
  '/sales/debug-fruitsys': typeof SalesDebugFruitsysRoute
  '/sales/integrations': typeof SalesIntegrationsRoute
  '/sales/invoices': typeof SalesInvoicesRoute
  '/sales/products': typeof SalesProductsRoute
  '/bank-transactions': typeof BankTransactionsIndexRoute
  '/cost-centers': typeof CostCentersIndexRoute
  '/inventory': typeof InventoryIndexRoute
  '/invoices': typeof InvoicesIndexRoute
  '/menus': typeof MenusIndexRoute
  '/metrics': typeof MetricsIndexRoute
  '/partners': typeof PartnersIndexRoute
  '/payments': typeof PaymentsIndexRoute
  '/people': typeof PeopleIndexRoute
  '/admin/integrations/connecteam': typeof AdminIntegrationsConnecteamRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/inventory/batches/$id': typeof InventoryBatchesIdRoute
  '/inventory/batches/receive-shipment': typeof InventoryBatchesReceiveShipmentRoute
  '/menus/$id/edit': typeof MenusIdEditRoute
  '/metrics/execute/$id': typeof MetricsExecuteIdRoute
  '/payments/$id/edit': typeof PaymentsIdEditRoute
  '/people/employees/$employeeId': typeof PeopleEmployeesEmployeeIdRoute
  '/people/schedulers/$id': typeof PeopleSchedulersIdRoute
  '/people/schedulers/generate-schedule': typeof PeopleSchedulersGenerateScheduleRoute
  '/people/timeoff/requests': typeof PeopleTimeoffRequestsRoute
  '/sales/orders/$id': typeof SalesOrdersIdRoute
  '/superadmin/tenants/$id': typeof SuperadminTenantsIdRoute
  '/superadmin/tenants/new': typeof SuperadminTenantsNewRoute
  '/admin/finance': typeof AdminFinanceIndexRoute
  '/admin/integrations': typeof AdminIntegrationsIndexRoute
  '/admin/people': typeof AdminPeopleIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/inventory/batches': typeof InventoryBatchesIndexRoute
  '/people/employees': typeof PeopleEmployeesIndexRoute
  '/people/schedulers': typeof PeopleSchedulersIndexRoute
  '/people/timeoff': typeof PeopleTimeoffIndexRoute
  '/sales/orders': typeof SalesOrdersIndexRoute
  '/superadmin/superadmins': typeof SuperadminSuperadminsIndexRoute
  '/superadmin/tenants': typeof SuperadminTenantsIndexRoute
  '/admin/finance/companies/$id': typeof AdminFinanceCompaniesIdRoute
  '/admin/finance/companies/new': typeof AdminFinanceCompaniesNewRoute
  '/admin/finance/payment-instruments/$id': typeof AdminFinancePaymentInstrumentsIdRoute
  '/admin/finance/payment-instruments/new': typeof AdminFinancePaymentInstrumentsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/categories': typeof CategoriesRoute
  '/cost-reports': typeof CostReportsRoute
  '/dashboard': typeof DashboardRoute
  '/home': typeof HomeRoute
  '/ingredients': typeof IngredientsRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/profit-loss': typeof ProfitLossRoute
  '/settings': typeof SettingsRoute
  '/superadmin-login': typeof SuperadminLoginRoute
  '/tags': typeof TagsRoute
  '/units': typeof UnitsRoute
  '/admin/category-management': typeof AdminCategoryManagementRoute
  '/admin/currencies': typeof AdminCurrenciesRoute
  '/admin/data-import': typeof AdminDataImportRoute
  '/admin/local-category-models': typeof AdminLocalCategoryModelsRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/tags': typeof AdminTagsRoute
  '/cost-centers/$id': typeof CostCentersIdRoute
  '/finance/reconciliation': typeof FinanceReconciliationRoute
  '/finance/taxes': typeof FinanceTaxesRoute
  '/inventory/master-ingredients': typeof InventoryMasterIngredientsRoute
  '/inventory/new': typeof InventoryNewRoute
  '/inventory/transactions': typeof InventoryTransactionsRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/gdrive-files': typeof InvoicesGdriveFilesRoute
  '/invoices/manual-match': typeof InvoicesManualMatchRoute
  '/invoices/upload': typeof InvoicesUploadRoute
  '/menus/$id': typeof MenusIdRouteWithChildren
  '/menus/new': typeof MenusNewRoute
  '/metrics/$id': typeof MetricsIdRoute
  '/partners/$id': typeof PartnersIdRoute
  '/payments/$id': typeof PaymentsIdRouteWithChildren
  '/payments/new': typeof PaymentsNewRoute
  '/people/contracts': typeof PeopleContractsRoute
  '/people/costs': typeof PeopleCostsRoute
  '/people/groups': typeof PeopleGroupsRoute
  '/people/timesheets': typeof PeopleTimesheetsRoute
  '/sales/dashboard': typeof SalesDashboardRoute
  '/sales/debug-fruitsys': typeof SalesDebugFruitsysRoute
  '/sales/integrations': typeof SalesIntegrationsRoute
  '/sales/invoices': typeof SalesInvoicesRoute
  '/sales/products': typeof SalesProductsRoute
  '/bank-transactions/': typeof BankTransactionsIndexRoute
  '/cost-centers/': typeof CostCentersIndexRoute
  '/inventory/': typeof InventoryIndexRoute
  '/invoices/': typeof InvoicesIndexRoute
  '/menus/': typeof MenusIndexRoute
  '/metrics/': typeof MetricsIndexRoute
  '/partners/': typeof PartnersIndexRoute
  '/payments/': typeof PaymentsIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/admin/integrations/connecteam': typeof AdminIntegrationsConnecteamRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/inventory/batches/$id': typeof InventoryBatchesIdRoute
  '/inventory/batches/receive-shipment': typeof InventoryBatchesReceiveShipmentRoute
  '/menus/$id/edit': typeof MenusIdEditRoute
  '/metrics/execute/$id': typeof MetricsExecuteIdRoute
  '/payments/$id/edit': typeof PaymentsIdEditRoute
  '/people/employees/$employeeId': typeof PeopleEmployeesEmployeeIdRoute
  '/people/schedulers/$id': typeof PeopleSchedulersIdRoute
  '/people/schedulers/generate-schedule': typeof PeopleSchedulersGenerateScheduleRoute
  '/people/timeoff/requests': typeof PeopleTimeoffRequestsRoute
  '/sales/orders/$id': typeof SalesOrdersIdRoute
  '/superadmin/tenants/$id': typeof SuperadminTenantsIdRoute
  '/superadmin/tenants/new': typeof SuperadminTenantsNewRoute
  '/admin/finance/': typeof AdminFinanceIndexRoute
  '/admin/integrations/': typeof AdminIntegrationsIndexRoute
  '/admin/people/': typeof AdminPeopleIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/inventory/batches/': typeof InventoryBatchesIndexRoute
  '/people/employees/': typeof PeopleEmployeesIndexRoute
  '/people/schedulers/': typeof PeopleSchedulersIndexRoute
  '/people/timeoff/': typeof PeopleTimeoffIndexRoute
  '/sales/orders/': typeof SalesOrdersIndexRoute
  '/superadmin/superadmins/': typeof SuperadminSuperadminsIndexRoute
  '/superadmin/tenants/': typeof SuperadminTenantsIndexRoute
  '/admin/finance/companies/$id': typeof AdminFinanceCompaniesIdRoute
  '/admin/finance/companies/new': typeof AdminFinanceCompaniesNewRoute
  '/admin/finance/payment-instruments/$id': typeof AdminFinancePaymentInstrumentsIdRoute
  '/admin/finance/payment-instruments/new': typeof AdminFinancePaymentInstrumentsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/categories'
    | '/cost-reports'
    | '/dashboard'
    | '/home'
    | '/ingredients'
    | '/login'
    | '/notifications'
    | '/profit-loss'
    | '/settings'
    | '/superadmin-login'
    | '/tags'
    | '/units'
    | '/admin/category-management'
    | '/admin/currencies'
    | '/admin/data-import'
    | '/admin/local-category-models'
    | '/admin/notifications'
    | '/admin/tags'
    | '/cost-centers/$id'
    | '/finance/reconciliation'
    | '/finance/taxes'
    | '/inventory/master-ingredients'
    | '/inventory/new'
    | '/inventory/transactions'
    | '/invoices/$id'
    | '/invoices/gdrive-files'
    | '/invoices/manual-match'
    | '/invoices/upload'
    | '/menus/$id'
    | '/menus/new'
    | '/metrics/$id'
    | '/partners/$id'
    | '/payments/$id'
    | '/payments/new'
    | '/people/contracts'
    | '/people/costs'
    | '/people/groups'
    | '/people/timesheets'
    | '/sales/dashboard'
    | '/sales/debug-fruitsys'
    | '/sales/integrations'
    | '/sales/invoices'
    | '/sales/products'
    | '/bank-transactions'
    | '/cost-centers'
    | '/inventory'
    | '/invoices'
    | '/menus'
    | '/metrics'
    | '/partners'
    | '/payments'
    | '/people'
    | '/admin/integrations/connecteam'
    | '/admin/users/$id'
    | '/inventory/batches/$id'
    | '/inventory/batches/receive-shipment'
    | '/menus/$id/edit'
    | '/metrics/execute/$id'
    | '/payments/$id/edit'
    | '/people/employees/$employeeId'
    | '/people/schedulers/$id'
    | '/people/schedulers/generate-schedule'
    | '/people/timeoff/requests'
    | '/sales/orders/$id'
    | '/superadmin/tenants/$id'
    | '/superadmin/tenants/new'
    | '/admin/finance'
    | '/admin/integrations'
    | '/admin/people'
    | '/admin/users'
    | '/inventory/batches'
    | '/people/employees'
    | '/people/schedulers'
    | '/people/timeoff'
    | '/sales/orders'
    | '/superadmin/superadmins'
    | '/superadmin/tenants'
    | '/admin/finance/companies/$id'
    | '/admin/finance/companies/new'
    | '/admin/finance/payment-instruments/$id'
    | '/admin/finance/payment-instruments/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/categories'
    | '/cost-reports'
    | '/dashboard'
    | '/home'
    | '/ingredients'
    | '/login'
    | '/notifications'
    | '/profit-loss'
    | '/settings'
    | '/superadmin-login'
    | '/tags'
    | '/units'
    | '/admin/category-management'
    | '/admin/currencies'
    | '/admin/data-import'
    | '/admin/local-category-models'
    | '/admin/notifications'
    | '/admin/tags'
    | '/cost-centers/$id'
    | '/finance/reconciliation'
    | '/finance/taxes'
    | '/inventory/master-ingredients'
    | '/inventory/new'
    | '/inventory/transactions'
    | '/invoices/$id'
    | '/invoices/gdrive-files'
    | '/invoices/manual-match'
    | '/invoices/upload'
    | '/menus/$id'
    | '/menus/new'
    | '/metrics/$id'
    | '/partners/$id'
    | '/payments/$id'
    | '/payments/new'
    | '/people/contracts'
    | '/people/costs'
    | '/people/groups'
    | '/people/timesheets'
    | '/sales/dashboard'
    | '/sales/debug-fruitsys'
    | '/sales/integrations'
    | '/sales/invoices'
    | '/sales/products'
    | '/bank-transactions'
    | '/cost-centers'
    | '/inventory'
    | '/invoices'
    | '/menus'
    | '/metrics'
    | '/partners'
    | '/payments'
    | '/people'
    | '/admin/integrations/connecteam'
    | '/admin/users/$id'
    | '/inventory/batches/$id'
    | '/inventory/batches/receive-shipment'
    | '/menus/$id/edit'
    | '/metrics/execute/$id'
    | '/payments/$id/edit'
    | '/people/employees/$employeeId'
    | '/people/schedulers/$id'
    | '/people/schedulers/generate-schedule'
    | '/people/timeoff/requests'
    | '/sales/orders/$id'
    | '/superadmin/tenants/$id'
    | '/superadmin/tenants/new'
    | '/admin/finance'
    | '/admin/integrations'
    | '/admin/people'
    | '/admin/users'
    | '/inventory/batches'
    | '/people/employees'
    | '/people/schedulers'
    | '/people/timeoff'
    | '/sales/orders'
    | '/superadmin/superadmins'
    | '/superadmin/tenants'
    | '/admin/finance/companies/$id'
    | '/admin/finance/companies/new'
    | '/admin/finance/payment-instruments/$id'
    | '/admin/finance/payment-instruments/new'
  id:
    | '__root__'
    | '/'
    | '/analytics'
    | '/categories'
    | '/cost-reports'
    | '/dashboard'
    | '/home'
    | '/ingredients'
    | '/login'
    | '/notifications'
    | '/profit-loss'
    | '/settings'
    | '/superadmin-login'
    | '/tags'
    | '/units'
    | '/admin/category-management'
    | '/admin/currencies'
    | '/admin/data-import'
    | '/admin/local-category-models'
    | '/admin/notifications'
    | '/admin/tags'
    | '/cost-centers/$id'
    | '/finance/reconciliation'
    | '/finance/taxes'
    | '/inventory/master-ingredients'
    | '/inventory/new'
    | '/inventory/transactions'
    | '/invoices/$id'
    | '/invoices/gdrive-files'
    | '/invoices/manual-match'
    | '/invoices/upload'
    | '/menus/$id'
    | '/menus/new'
    | '/metrics/$id'
    | '/partners/$id'
    | '/payments/$id'
    | '/payments/new'
    | '/people/contracts'
    | '/people/costs'
    | '/people/groups'
    | '/people/timesheets'
    | '/sales/dashboard'
    | '/sales/debug-fruitsys'
    | '/sales/integrations'
    | '/sales/invoices'
    | '/sales/products'
    | '/bank-transactions/'
    | '/cost-centers/'
    | '/inventory/'
    | '/invoices/'
    | '/menus/'
    | '/metrics/'
    | '/partners/'
    | '/payments/'
    | '/people/'
    | '/admin/integrations/connecteam'
    | '/admin/users/$id'
    | '/inventory/batches/$id'
    | '/inventory/batches/receive-shipment'
    | '/menus/$id/edit'
    | '/metrics/execute/$id'
    | '/payments/$id/edit'
    | '/people/employees/$employeeId'
    | '/people/schedulers/$id'
    | '/people/schedulers/generate-schedule'
    | '/people/timeoff/requests'
    | '/sales/orders/$id'
    | '/superadmin/tenants/$id'
    | '/superadmin/tenants/new'
    | '/admin/finance/'
    | '/admin/integrations/'
    | '/admin/people/'
    | '/admin/users/'
    | '/inventory/batches/'
    | '/people/employees/'
    | '/people/schedulers/'
    | '/people/timeoff/'
    | '/sales/orders/'
    | '/superadmin/superadmins/'
    | '/superadmin/tenants/'
    | '/admin/finance/companies/$id'
    | '/admin/finance/companies/new'
    | '/admin/finance/payment-instruments/$id'
    | '/admin/finance/payment-instruments/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsRoute: typeof AnalyticsRoute
  CategoriesRoute: typeof CategoriesRoute
  CostReportsRoute: typeof CostReportsRoute
  DashboardRoute: typeof DashboardRoute
  HomeRoute: typeof HomeRoute
  IngredientsRoute: typeof IngredientsRoute
  LoginRoute: typeof LoginRoute
  NotificationsRoute: typeof NotificationsRoute
  ProfitLossRoute: typeof ProfitLossRoute
  SettingsRoute: typeof SettingsRoute
  SuperadminLoginRoute: typeof SuperadminLoginRoute
  TagsRoute: typeof TagsRoute
  UnitsRoute: typeof UnitsRoute
  AdminCategoryManagementRoute: typeof AdminCategoryManagementRoute
  AdminCurrenciesRoute: typeof AdminCurrenciesRoute
  AdminDataImportRoute: typeof AdminDataImportRoute
  AdminLocalCategoryModelsRoute: typeof AdminLocalCategoryModelsRoute
  AdminNotificationsRoute: typeof AdminNotificationsRoute
  AdminTagsRoute: typeof AdminTagsRoute
  CostCentersIdRoute: typeof CostCentersIdRoute
  FinanceReconciliationRoute: typeof FinanceReconciliationRoute
  FinanceTaxesRoute: typeof FinanceTaxesRoute
  InventoryMasterIngredientsRoute: typeof InventoryMasterIngredientsRoute
  InventoryNewRoute: typeof InventoryNewRoute
  InventoryTransactionsRoute: typeof InventoryTransactionsRoute
  InvoicesIdRoute: typeof InvoicesIdRoute
  InvoicesGdriveFilesRoute: typeof InvoicesGdriveFilesRoute
  InvoicesManualMatchRoute: typeof InvoicesManualMatchRoute
  InvoicesUploadRoute: typeof InvoicesUploadRoute
  MenusIdRoute: typeof MenusIdRouteWithChildren
  MenusNewRoute: typeof MenusNewRoute
  MetricsIdRoute: typeof MetricsIdRoute
  PartnersIdRoute: typeof PartnersIdRoute
  PaymentsIdRoute: typeof PaymentsIdRouteWithChildren
  PaymentsNewRoute: typeof PaymentsNewRoute
  PeopleContractsRoute: typeof PeopleContractsRoute
  PeopleCostsRoute: typeof PeopleCostsRoute
  PeopleGroupsRoute: typeof PeopleGroupsRoute
  PeopleTimesheetsRoute: typeof PeopleTimesheetsRoute
  SalesDashboardRoute: typeof SalesDashboardRoute
  SalesDebugFruitsysRoute: typeof SalesDebugFruitsysRoute
  SalesIntegrationsRoute: typeof SalesIntegrationsRoute
  SalesInvoicesRoute: typeof SalesInvoicesRoute
  SalesProductsRoute: typeof SalesProductsRoute
  BankTransactionsIndexRoute: typeof BankTransactionsIndexRoute
  CostCentersIndexRoute: typeof CostCentersIndexRoute
  InventoryIndexRoute: typeof InventoryIndexRoute
  InvoicesIndexRoute: typeof InvoicesIndexRoute
  MenusIndexRoute: typeof MenusIndexRoute
  MetricsIndexRoute: typeof MetricsIndexRoute
  PartnersIndexRoute: typeof PartnersIndexRoute
  PaymentsIndexRoute: typeof PaymentsIndexRoute
  PeopleIndexRoute: typeof PeopleIndexRoute
  AdminIntegrationsConnecteamRoute: typeof AdminIntegrationsConnecteamRoute
  AdminUsersIdRoute: typeof AdminUsersIdRoute
  InventoryBatchesIdRoute: typeof InventoryBatchesIdRoute
  InventoryBatchesReceiveShipmentRoute: typeof InventoryBatchesReceiveShipmentRoute
  MetricsExecuteIdRoute: typeof MetricsExecuteIdRoute
  PeopleEmployeesEmployeeIdRoute: typeof PeopleEmployeesEmployeeIdRoute
  PeopleSchedulersIdRoute: typeof PeopleSchedulersIdRoute
  PeopleSchedulersGenerateScheduleRoute: typeof PeopleSchedulersGenerateScheduleRoute
  PeopleTimeoffRequestsRoute: typeof PeopleTimeoffRequestsRoute
  SalesOrdersIdRoute: typeof SalesOrdersIdRoute
  SuperadminTenantsIdRoute: typeof SuperadminTenantsIdRoute
  SuperadminTenantsNewRoute: typeof SuperadminTenantsNewRoute
  AdminFinanceIndexRoute: typeof AdminFinanceIndexRoute
  AdminIntegrationsIndexRoute: typeof AdminIntegrationsIndexRoute
  AdminPeopleIndexRoute: typeof AdminPeopleIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  InventoryBatchesIndexRoute: typeof InventoryBatchesIndexRoute
  PeopleEmployeesIndexRoute: typeof PeopleEmployeesIndexRoute
  PeopleSchedulersIndexRoute: typeof PeopleSchedulersIndexRoute
  PeopleTimeoffIndexRoute: typeof PeopleTimeoffIndexRoute
  SalesOrdersIndexRoute: typeof SalesOrdersIndexRoute
  SuperadminSuperadminsIndexRoute: typeof SuperadminSuperadminsIndexRoute
  SuperadminTenantsIndexRoute: typeof SuperadminTenantsIndexRoute
  AdminFinanceCompaniesIdRoute: typeof AdminFinanceCompaniesIdRoute
  AdminFinanceCompaniesNewRoute: typeof AdminFinanceCompaniesNewRoute
  AdminFinancePaymentInstrumentsIdRoute: typeof AdminFinancePaymentInstrumentsIdRoute
  AdminFinancePaymentInstrumentsNewRoute: typeof AdminFinancePaymentInstrumentsNewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/units': {
      id: '/units'
      path: '/units'
      fullPath: '/units'
      preLoaderRoute: typeof UnitsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tags': {
      id: '/tags'
      path: '/tags'
      fullPath: '/tags'
      preLoaderRoute: typeof TagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/superadmin-login': {
      id: '/superadmin-login'
      path: '/superadmin-login'
      fullPath: '/superadmin-login'
      preLoaderRoute: typeof SuperadminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profit-loss': {
      id: '/profit-loss'
      path: '/profit-loss'
      fullPath: '/profit-loss'
      preLoaderRoute: typeof ProfitLossRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ingredients': {
      id: '/ingredients'
      path: '/ingredients'
      fullPath: '/ingredients'
      preLoaderRoute: typeof IngredientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cost-reports': {
      id: '/cost-reports'
      path: '/cost-reports'
      fullPath: '/cost-reports'
      preLoaderRoute: typeof CostReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories': {
      id: '/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof CategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/': {
      id: '/people/'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof PeopleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/': {
      id: '/payments/'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof PaymentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners/': {
      id: '/partners/'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof PartnersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/metrics/': {
      id: '/metrics/'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof MetricsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menus/': {
      id: '/menus/'
      path: '/menus'
      fullPath: '/menus'
      preLoaderRoute: typeof MenusIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/': {
      id: '/invoices/'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/': {
      id: '/inventory/'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cost-centers/': {
      id: '/cost-centers/'
      path: '/cost-centers'
      fullPath: '/cost-centers'
      preLoaderRoute: typeof CostCentersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bank-transactions/': {
      id: '/bank-transactions/'
      path: '/bank-transactions'
      fullPath: '/bank-transactions'
      preLoaderRoute: typeof BankTransactionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/products': {
      id: '/sales/products'
      path: '/sales/products'
      fullPath: '/sales/products'
      preLoaderRoute: typeof SalesProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/invoices': {
      id: '/sales/invoices'
      path: '/sales/invoices'
      fullPath: '/sales/invoices'
      preLoaderRoute: typeof SalesInvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/integrations': {
      id: '/sales/integrations'
      path: '/sales/integrations'
      fullPath: '/sales/integrations'
      preLoaderRoute: typeof SalesIntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/debug-fruitsys': {
      id: '/sales/debug-fruitsys'
      path: '/sales/debug-fruitsys'
      fullPath: '/sales/debug-fruitsys'
      preLoaderRoute: typeof SalesDebugFruitsysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/dashboard': {
      id: '/sales/dashboard'
      path: '/sales/dashboard'
      fullPath: '/sales/dashboard'
      preLoaderRoute: typeof SalesDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/timesheets': {
      id: '/people/timesheets'
      path: '/people/timesheets'
      fullPath: '/people/timesheets'
      preLoaderRoute: typeof PeopleTimesheetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/groups': {
      id: '/people/groups'
      path: '/people/groups'
      fullPath: '/people/groups'
      preLoaderRoute: typeof PeopleGroupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/costs': {
      id: '/people/costs'
      path: '/people/costs'
      fullPath: '/people/costs'
      preLoaderRoute: typeof PeopleCostsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/contracts': {
      id: '/people/contracts'
      path: '/people/contracts'
      fullPath: '/people/contracts'
      preLoaderRoute: typeof PeopleContractsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/new': {
      id: '/payments/new'
      path: '/payments/new'
      fullPath: '/payments/new'
      preLoaderRoute: typeof PaymentsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/$id': {
      id: '/payments/$id'
      path: '/payments/$id'
      fullPath: '/payments/$id'
      preLoaderRoute: typeof PaymentsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners/$id': {
      id: '/partners/$id'
      path: '/partners/$id'
      fullPath: '/partners/$id'
      preLoaderRoute: typeof PartnersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/metrics/$id': {
      id: '/metrics/$id'
      path: '/metrics/$id'
      fullPath: '/metrics/$id'
      preLoaderRoute: typeof MetricsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menus/new': {
      id: '/menus/new'
      path: '/menus/new'
      fullPath: '/menus/new'
      preLoaderRoute: typeof MenusNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menus/$id': {
      id: '/menus/$id'
      path: '/menus/$id'
      fullPath: '/menus/$id'
      preLoaderRoute: typeof MenusIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/upload': {
      id: '/invoices/upload'
      path: '/invoices/upload'
      fullPath: '/invoices/upload'
      preLoaderRoute: typeof InvoicesUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/manual-match': {
      id: '/invoices/manual-match'
      path: '/invoices/manual-match'
      fullPath: '/invoices/manual-match'
      preLoaderRoute: typeof InvoicesManualMatchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/gdrive-files': {
      id: '/invoices/gdrive-files'
      path: '/invoices/gdrive-files'
      fullPath: '/invoices/gdrive-files'
      preLoaderRoute: typeof InvoicesGdriveFilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/$id': {
      id: '/invoices/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof InvoicesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/transactions': {
      id: '/inventory/transactions'
      path: '/inventory/transactions'
      fullPath: '/inventory/transactions'
      preLoaderRoute: typeof InventoryTransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/new': {
      id: '/inventory/new'
      path: '/inventory/new'
      fullPath: '/inventory/new'
      preLoaderRoute: typeof InventoryNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/master-ingredients': {
      id: '/inventory/master-ingredients'
      path: '/inventory/master-ingredients'
      fullPath: '/inventory/master-ingredients'
      preLoaderRoute: typeof InventoryMasterIngredientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/taxes': {
      id: '/finance/taxes'
      path: '/finance/taxes'
      fullPath: '/finance/taxes'
      preLoaderRoute: typeof FinanceTaxesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/reconciliation': {
      id: '/finance/reconciliation'
      path: '/finance/reconciliation'
      fullPath: '/finance/reconciliation'
      preLoaderRoute: typeof FinanceReconciliationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cost-centers/$id': {
      id: '/cost-centers/$id'
      path: '/cost-centers/$id'
      fullPath: '/cost-centers/$id'
      preLoaderRoute: typeof CostCentersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tags': {
      id: '/admin/tags'
      path: '/admin/tags'
      fullPath: '/admin/tags'
      preLoaderRoute: typeof AdminTagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/notifications': {
      id: '/admin/notifications'
      path: '/admin/notifications'
      fullPath: '/admin/notifications'
      preLoaderRoute: typeof AdminNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/local-category-models': {
      id: '/admin/local-category-models'
      path: '/admin/local-category-models'
      fullPath: '/admin/local-category-models'
      preLoaderRoute: typeof AdminLocalCategoryModelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/data-import': {
      id: '/admin/data-import'
      path: '/admin/data-import'
      fullPath: '/admin/data-import'
      preLoaderRoute: typeof AdminDataImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/currencies': {
      id: '/admin/currencies'
      path: '/admin/currencies'
      fullPath: '/admin/currencies'
      preLoaderRoute: typeof AdminCurrenciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/category-management': {
      id: '/admin/category-management'
      path: '/admin/category-management'
      fullPath: '/admin/category-management'
      preLoaderRoute: typeof AdminCategoryManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/superadmin/tenants/': {
      id: '/superadmin/tenants/'
      path: '/superadmin/tenants'
      fullPath: '/superadmin/tenants'
      preLoaderRoute: typeof SuperadminTenantsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/superadmin/superadmins/': {
      id: '/superadmin/superadmins/'
      path: '/superadmin/superadmins'
      fullPath: '/superadmin/superadmins'
      preLoaderRoute: typeof SuperadminSuperadminsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/orders/': {
      id: '/sales/orders/'
      path: '/sales/orders'
      fullPath: '/sales/orders'
      preLoaderRoute: typeof SalesOrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/timeoff/': {
      id: '/people/timeoff/'
      path: '/people/timeoff'
      fullPath: '/people/timeoff'
      preLoaderRoute: typeof PeopleTimeoffIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/schedulers/': {
      id: '/people/schedulers/'
      path: '/people/schedulers'
      fullPath: '/people/schedulers'
      preLoaderRoute: typeof PeopleSchedulersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/employees/': {
      id: '/people/employees/'
      path: '/people/employees'
      fullPath: '/people/employees'
      preLoaderRoute: typeof PeopleEmployeesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/batches/': {
      id: '/inventory/batches/'
      path: '/inventory/batches'
      fullPath: '/inventory/batches'
      preLoaderRoute: typeof InventoryBatchesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/people/': {
      id: '/admin/people/'
      path: '/admin/people'
      fullPath: '/admin/people'
      preLoaderRoute: typeof AdminPeopleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/integrations/': {
      id: '/admin/integrations/'
      path: '/admin/integrations'
      fullPath: '/admin/integrations'
      preLoaderRoute: typeof AdminIntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/finance/': {
      id: '/admin/finance/'
      path: '/admin/finance'
      fullPath: '/admin/finance'
      preLoaderRoute: typeof AdminFinanceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/superadmin/tenants/new': {
      id: '/superadmin/tenants/new'
      path: '/superadmin/tenants/new'
      fullPath: '/superadmin/tenants/new'
      preLoaderRoute: typeof SuperadminTenantsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/superadmin/tenants/$id': {
      id: '/superadmin/tenants/$id'
      path: '/superadmin/tenants/$id'
      fullPath: '/superadmin/tenants/$id'
      preLoaderRoute: typeof SuperadminTenantsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/orders/$id': {
      id: '/sales/orders/$id'
      path: '/sales/orders/$id'
      fullPath: '/sales/orders/$id'
      preLoaderRoute: typeof SalesOrdersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/timeoff/requests': {
      id: '/people/timeoff/requests'
      path: '/people/timeoff/requests'
      fullPath: '/people/timeoff/requests'
      preLoaderRoute: typeof PeopleTimeoffRequestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/schedulers/generate-schedule': {
      id: '/people/schedulers/generate-schedule'
      path: '/people/schedulers/generate-schedule'
      fullPath: '/people/schedulers/generate-schedule'
      preLoaderRoute: typeof PeopleSchedulersGenerateScheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/schedulers/$id': {
      id: '/people/schedulers/$id'
      path: '/people/schedulers/$id'
      fullPath: '/people/schedulers/$id'
      preLoaderRoute: typeof PeopleSchedulersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/employees/$employeeId': {
      id: '/people/employees/$employeeId'
      path: '/people/employees/$employeeId'
      fullPath: '/people/employees/$employeeId'
      preLoaderRoute: typeof PeopleEmployeesEmployeeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/$id/edit': {
      id: '/payments/$id/edit'
      path: '/edit'
      fullPath: '/payments/$id/edit'
      preLoaderRoute: typeof PaymentsIdEditRouteImport
      parentRoute: typeof PaymentsIdRoute
    }
    '/metrics/execute/$id': {
      id: '/metrics/execute/$id'
      path: '/metrics/execute/$id'
      fullPath: '/metrics/execute/$id'
      preLoaderRoute: typeof MetricsExecuteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menus/$id/edit': {
      id: '/menus/$id/edit'
      path: '/edit'
      fullPath: '/menus/$id/edit'
      preLoaderRoute: typeof MenusIdEditRouteImport
      parentRoute: typeof MenusIdRoute
    }
    '/inventory/batches/receive-shipment': {
      id: '/inventory/batches/receive-shipment'
      path: '/inventory/batches/receive-shipment'
      fullPath: '/inventory/batches/receive-shipment'
      preLoaderRoute: typeof InventoryBatchesReceiveShipmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/batches/$id': {
      id: '/inventory/batches/$id'
      path: '/inventory/batches/$id'
      fullPath: '/inventory/batches/$id'
      preLoaderRoute: typeof InventoryBatchesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/$id': {
      id: '/admin/users/$id'
      path: '/admin/users/$id'
      fullPath: '/admin/users/$id'
      preLoaderRoute: typeof AdminUsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/integrations/connecteam': {
      id: '/admin/integrations/connecteam'
      path: '/admin/integrations/connecteam'
      fullPath: '/admin/integrations/connecteam'
      preLoaderRoute: typeof AdminIntegrationsConnecteamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/finance/payment-instruments/new': {
      id: '/admin/finance/payment-instruments/new'
      path: '/admin/finance/payment-instruments/new'
      fullPath: '/admin/finance/payment-instruments/new'
      preLoaderRoute: typeof AdminFinancePaymentInstrumentsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/finance/payment-instruments/$id': {
      id: '/admin/finance/payment-instruments/$id'
      path: '/admin/finance/payment-instruments/$id'
      fullPath: '/admin/finance/payment-instruments/$id'
      preLoaderRoute: typeof AdminFinancePaymentInstrumentsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/finance/companies/new': {
      id: '/admin/finance/companies/new'
      path: '/admin/finance/companies/new'
      fullPath: '/admin/finance/companies/new'
      preLoaderRoute: typeof AdminFinanceCompaniesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/finance/companies/$id': {
      id: '/admin/finance/companies/$id'
      path: '/admin/finance/companies/$id'
      fullPath: '/admin/finance/companies/$id'
      preLoaderRoute: typeof AdminFinanceCompaniesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface MenusIdRouteChildren {
  MenusIdEditRoute: typeof MenusIdEditRoute
}

const MenusIdRouteChildren: MenusIdRouteChildren = {
  MenusIdEditRoute: MenusIdEditRoute,
}

const MenusIdRouteWithChildren =
  MenusIdRoute._addFileChildren(MenusIdRouteChildren)

interface PaymentsIdRouteChildren {
  PaymentsIdEditRoute: typeof PaymentsIdEditRoute
}

const PaymentsIdRouteChildren: PaymentsIdRouteChildren = {
  PaymentsIdEditRoute: PaymentsIdEditRoute,
}

const PaymentsIdRouteWithChildren = PaymentsIdRoute._addFileChildren(
  PaymentsIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsRoute: AnalyticsRoute,
  CategoriesRoute: CategoriesRoute,
  CostReportsRoute: CostReportsRoute,
  DashboardRoute: DashboardRoute,
  HomeRoute: HomeRoute,
  IngredientsRoute: IngredientsRoute,
  LoginRoute: LoginRoute,
  NotificationsRoute: NotificationsRoute,
  ProfitLossRoute: ProfitLossRoute,
  SettingsRoute: SettingsRoute,
  SuperadminLoginRoute: SuperadminLoginRoute,
  TagsRoute: TagsRoute,
  UnitsRoute: UnitsRoute,
  AdminCategoryManagementRoute: AdminCategoryManagementRoute,
  AdminCurrenciesRoute: AdminCurrenciesRoute,
  AdminDataImportRoute: AdminDataImportRoute,
  AdminLocalCategoryModelsRoute: AdminLocalCategoryModelsRoute,
  AdminNotificationsRoute: AdminNotificationsRoute,
  AdminTagsRoute: AdminTagsRoute,
  CostCentersIdRoute: CostCentersIdRoute,
  FinanceReconciliationRoute: FinanceReconciliationRoute,
  FinanceTaxesRoute: FinanceTaxesRoute,
  InventoryMasterIngredientsRoute: InventoryMasterIngredientsRoute,
  InventoryNewRoute: InventoryNewRoute,
  InventoryTransactionsRoute: InventoryTransactionsRoute,
  InvoicesIdRoute: InvoicesIdRoute,
  InvoicesGdriveFilesRoute: InvoicesGdriveFilesRoute,
  InvoicesManualMatchRoute: InvoicesManualMatchRoute,
  InvoicesUploadRoute: InvoicesUploadRoute,
  MenusIdRoute: MenusIdRouteWithChildren,
  MenusNewRoute: MenusNewRoute,
  MetricsIdRoute: MetricsIdRoute,
  PartnersIdRoute: PartnersIdRoute,
  PaymentsIdRoute: PaymentsIdRouteWithChildren,
  PaymentsNewRoute: PaymentsNewRoute,
  PeopleContractsRoute: PeopleContractsRoute,
  PeopleCostsRoute: PeopleCostsRoute,
  PeopleGroupsRoute: PeopleGroupsRoute,
  PeopleTimesheetsRoute: PeopleTimesheetsRoute,
  SalesDashboardRoute: SalesDashboardRoute,
  SalesDebugFruitsysRoute: SalesDebugFruitsysRoute,
  SalesIntegrationsRoute: SalesIntegrationsRoute,
  SalesInvoicesRoute: SalesInvoicesRoute,
  SalesProductsRoute: SalesProductsRoute,
  BankTransactionsIndexRoute: BankTransactionsIndexRoute,
  CostCentersIndexRoute: CostCentersIndexRoute,
  InventoryIndexRoute: InventoryIndexRoute,
  InvoicesIndexRoute: InvoicesIndexRoute,
  MenusIndexRoute: MenusIndexRoute,
  MetricsIndexRoute: MetricsIndexRoute,
  PartnersIndexRoute: PartnersIndexRoute,
  PaymentsIndexRoute: PaymentsIndexRoute,
  PeopleIndexRoute: PeopleIndexRoute,
  AdminIntegrationsConnecteamRoute: AdminIntegrationsConnecteamRoute,
  AdminUsersIdRoute: AdminUsersIdRoute,
  InventoryBatchesIdRoute: InventoryBatchesIdRoute,
  InventoryBatchesReceiveShipmentRoute: InventoryBatchesReceiveShipmentRoute,
  MetricsExecuteIdRoute: MetricsExecuteIdRoute,
  PeopleEmployeesEmployeeIdRoute: PeopleEmployeesEmployeeIdRoute,
  PeopleSchedulersIdRoute: PeopleSchedulersIdRoute,
  PeopleSchedulersGenerateScheduleRoute: PeopleSchedulersGenerateScheduleRoute,
  PeopleTimeoffRequestsRoute: PeopleTimeoffRequestsRoute,
  SalesOrdersIdRoute: SalesOrdersIdRoute,
  SuperadminTenantsIdRoute: SuperadminTenantsIdRoute,
  SuperadminTenantsNewRoute: SuperadminTenantsNewRoute,
  AdminFinanceIndexRoute: AdminFinanceIndexRoute,
  AdminIntegrationsIndexRoute: AdminIntegrationsIndexRoute,
  AdminPeopleIndexRoute: AdminPeopleIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  InventoryBatchesIndexRoute: InventoryBatchesIndexRoute,
  PeopleEmployeesIndexRoute: PeopleEmployeesIndexRoute,
  PeopleSchedulersIndexRoute: PeopleSchedulersIndexRoute,
  PeopleTimeoffIndexRoute: PeopleTimeoffIndexRoute,
  SalesOrdersIndexRoute: SalesOrdersIndexRoute,
  SuperadminSuperadminsIndexRoute: SuperadminSuperadminsIndexRoute,
  SuperadminTenantsIndexRoute: SuperadminTenantsIndexRoute,
  AdminFinanceCompaniesIdRoute: AdminFinanceCompaniesIdRoute,
  AdminFinanceCompaniesNewRoute: AdminFinanceCompaniesNewRoute,
  AdminFinancePaymentInstrumentsIdRoute: AdminFinancePaymentInstrumentsIdRoute,
  AdminFinancePaymentInstrumentsNewRoute:
    AdminFinancePaymentInstrumentsNewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
